import { useState, useEffect } from 'react'
import { LOCAL, DEVELOP } from 'constants/env'

const config = process.env.NODE_ENV === 'development' ? LOCAL : DEVELOP

export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkAdmin = async (): Promise<void> => {
      try {
        const res = await fetch(`${config.API_URL}/api/admin/check`)
        const data = await res.json()
        setIsAdmin(data.isAdmin === true)
      } catch {
        setIsAdmin(false)
      } finally {
        setLoading(false)
      }
    }
    void checkAdmin()
  }, [])

  return { isAdmin, loading }
}
